import React from "react";
import "./stylesheet/form-management.scss";
import FormManagement from "./components/FormManagement";

function App() {
  return <FormManagement />;
}

export default App;
